import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { ContestHandoverDisputesCollection } from './contest-handover-disputes.types';

export function contestHandoverDisputesBackend(): Backend<ContestHandoverDisputesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (_, dispute) => {
      if (!dispute.handoverId) {
        throw new Error('Missing handover ID when trying to create dispute');
      }
      if (!dispute.description || typeof dispute.description !== 'string') {
        throw new Error(
          'Missing or invalid description when trying to create dispute',
        );
      }
      return {
        endpoint: `contests/0.1/handovers/${dispute.handoverId}/disputes/`,
        payload: {
          handover_id: dispute.handoverId,
          description: dispute.description,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
